module.exports = __webpack_public_path__ + "static/media/smart_zitsa.5d5ac013.jpg";